(function ($, Drupal, once) {

  var DURATION = 500;
  var FRAME_MS = 16;
  var TOTAL_FRAMES = Math.round(DURATION / FRAME_MS);

  function easeOutQuad(t) {
    return t * (2 - t);
  }

  function getNumberParams(el) {
    var end = parseFloat(el.getAttribute('data-value'));
    if (isNaN(end)) return null;
    var from = el.getAttribute('data-animate-from');
    var start = (from !== null && from !== '') ? parseFloat(from) : 0;
    if (isNaN(start)) start = 0;
    var decimals = String(end).indexOf('.') !== -1
      ? (String(end).split('.')[1] || '').length
      : 0;
    return { start: start, end: end, decimals: decimals };
  }

  function formatNumber(value, decimals) {
    return decimals ? value.toFixed(decimals) : Math.round(value);
  }

  function setToStart(el) {
    var p = getNumberParams(el);
    if (p) el.textContent = formatNumber(p.start, p.decimals);
  }

  function animateNumber(el) {
    return new Promise(function (resolve) {
      var p = getNumberParams(el);
      if (!p) { resolve(); return; }

      var frame = 0;
      el.textContent = formatNumber(p.start, p.decimals);

      var counter = setInterval(function () {
        frame++;
        var progress = easeOutQuad(frame / TOTAL_FRAMES);
        el.textContent = formatNumber(p.start + (p.end - p.start) * progress, p.decimals);

        if (frame === TOTAL_FRAMES) {
          clearInterval(counter);
          el.textContent = formatNumber(p.end, p.decimals);
          resolve();
        }
      }, FRAME_MS);
    });
  }

  function animateStat(statEl) {
    statEl.style.opacity = '1';
    statEl.style.transform = 'translateY(0)';

    var numberEl = statEl.querySelector('.stat__number[data-value]');
    if (numberEl) return animateNumber(numberEl);

    return new Promise(function (resolve) { setTimeout(resolve, 600); });
  }

  function animateSequentially(els, index) {
    if (index >= els.length) return;
    animateStat(els[index]).then(function () {
      animateSequentially(els, index + 1);
    });
  }

  Drupal.behaviors.statNumberAnimate = {
    attach: function (context) {
      once('stat-number-animate', '.paragraph--type--stats', context).forEach(function (container) {
        var statEls = container.querySelectorAll('.stat');
        if (!statEls.length) return;

        var statNumbers = container.querySelectorAll('.stat__number[data-value]');

        // Initial hidden state.
        statEls.forEach(function (el) {
          el.style.opacity = '0';
          el.style.transform = 'translateY(30px)';
          el.style.transition = 'opacity 1s ease-out, transform 0.6s ease-out';
        });
        statNumbers.forEach(setToStart);

        var animated = false;

        // Animate on scroll down into view.
        new IntersectionObserver(function (entries) {
          if (!animated && entries[0].isIntersecting && container.getBoundingClientRect().top >= 0) {
            animated = true;
            animateSequentially(statEls, 0);
          }
        }, { threshold: 0.2 }).observe(container);

        // Reset when stats leave below the viewport (user scrolled back up).
        new IntersectionObserver(function (entries) {
          if (animated && !entries[0].isIntersecting && container.getBoundingClientRect().top > window.innerHeight) {
            animated = false;
            statEls.forEach(function (el) {
              el.style.opacity = '0';
              el.style.transform = 'translateY(30px)';
            });
            statNumbers.forEach(setToStart);
          }
        }, { threshold: 0 }).observe(container);
      });
    }
  };
})(jQuery, Drupal, once);
